// axiosInstance, not the cachios client — see enrollments.js
import {axiosInstance as http} from "@/http_client";

export default {
    state: {
        registrations: null
    },
    getters: {
        registrations: state => state.registrations
    },
    mutations: {
        setRegistrations(state, registrations) {
            state.registrations = registrations;
        }
    },
    actions: {
        getRegistrations({commit, rootGetters}) {
            // Drop a late response for a user who is no longer current
            // (portal login-as-user relay) — see enrollments.js
            const forUser = rootGetters.currentUser && rootGetters.currentUser.id;
            return new Promise((resolve, reject) => {
                http.get('app/registrations/').then(response => {
                    const nowUser = rootGetters.currentUser && rootGetters.currentUser.id;
                    if (nowUser !== forUser) return resolve(null);
                    commit('setRegistrations', response.data);
                    resolve(response.data);
                }).catch(err => {
                    console.log('err', err);
                    reject(err.response);
                });
            });
        },
    }
};
